import { Fragment } from "react";
import { autoCompleteDisplayLabel } from "./Common";
import { formatGenericDate, formatPhoneNumber, formatCurrency, isFutureDate } from "./util";
import styled from "@emotion/styled";

import { lighten } from "@mui/material/styles";

import { capitalize } from "lodash";

const SimpleChip = styled.div`
  background-color: ${props => props.$bgcolor ? props.$bgcolor : lighten(props.theme.colors.success, 0.9)};
  color: ${props => props.$color ? props.$color : props.theme.colors.success};
  border-radius: 3px;
  padding: .4rem .5rem;
  font-weight: 500;
`;

const WeddingDate = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 999px;
  background: #fdf2f8;
  color: #be185d;
  font-size: 0.85em;
  font-weight: 500;
  white-space: nowrap;

  strong {
    font-weight: 600;
  }
`;

const displayLabelWig = (option) => {
  let status;
  if (option?.status === "sold") {
    status = `Sold On ${formatGenericDate(option?.last_log_date, "short")} To ${option?.customer_name}`
  } else if (option?.status === "removed") {
    status = "Returned";
  } else if (option?.status === "assigned") {
    status = `Assigned To ${option?.customer_name}`;
  } else {
    status = "In Stock"
  }
  let info = <div><span style={{fontWeight: "600"}}>{option?.brand_name}</span> &middot; {option?.sku} &middot; <span style={{fontStyle: "italic"}}>{status}</span></div>
  return autoCompleteDisplayLabel(option?.wig_id, info);
}

const displayInventoryItemLabel = (option) => {
  let info = <div><span>Wigs In Stock: &nbsp;<strong>{option?.current_stock}</strong></span> &nbsp; &middot; &nbsp; <span>Cost: &nbsp; <strong>{formatCurrency(option?.cost_total)}</strong></span> &nbsp; &middot; &nbsp; <span>Price: &nbsp;<strong>{formatCurrency(option?.total_price)}</strong></span></div>;
  return autoCompleteDisplayLabel(option?.sku, info);
}

const displayLabelCustomer = (option, display = "full") => {
  const parts = [];

  if (option?.mobile_phone) parts.push(formatPhoneNumber(option.mobile_phone));

  if (display === "full") {
    if (option?.email) parts.push(option.email);
    if (isFutureDate(option?.wedding_date)) {
      parts.push(
        <WeddingDate>
          Wedding <strong>{formatGenericDate(option.wedding_date, "short")}</strong>
        </WeddingDate>
      );
    }
  }

  const info = (
    <div>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <span> &middot; </span>}
          <span>{part}</span>
        </Fragment>
      ))}
    </div>
  );

  return autoCompleteDisplayLabel(option?.full_name, info);
};


const displayLabelVendor = (option) => {
  let info = <div>{formatPhoneNumber(option?.mobile_phone)} &middot; <span>{option?.email}</span></div>
  return autoCompleteDisplayLabel(option?.full_name, info);
};

const displayLabelService = (option) => {
  let info = <div>{option?.default_duration_in_minutes || option?.duration_in_minutes} min  &middot;  {formatCurrency(option?.default_price || option?.service_price)}</div>
  return autoCompleteDisplayLabel(option?.name, info);
}

const displayLabelProduct = (option) => {
  let info = <div>{option?.quantity_in_stock} in stock  &middot;  {formatCurrency(option?.price)}</div>
  return autoCompleteDisplayLabel(option?.name, info);
}

const displayLabelRepair = (option) => {
  let info = <div>{option?.in_house ? "In House" : "Vendor Repair"}</div>
  return autoCompleteDisplayLabel(option?.name, info);
}
  

const displayLabelAdjustment = (option) => {
  let rateStr;
  if (option?.rate_type === "percentage") {
    rateStr = `${option?.rate}%`;
  } else {
    rateStr = formatCurrency(option?.rate);
  }
  rateStr = option?.adjustment_type === "discount" ? `-${rateStr}` : `+${rateStr}`
  let active = option?.is_active ? "Active" : "Inactive";
  let info = <div>{rateStr} &middot; <span>{capitalize(option?.adjustment_type)}</span></div>
  return autoCompleteDisplayLabel(option?.title, info);
};

export { displayLabelWig, displayLabelCustomer, displayLabelAdjustment, displayLabelVendor, displayLabelService, displayInventoryItemLabel, displayLabelProduct, displayLabelRepair };